import React from 'react';
import { Color, COLORS } from '../../styles/variables';

interface MapIconProps {
  color?: Color;
  size?: number;
}

const MapIcon: React.FC<MapIconProps> = ({ color = COLORS.white, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.58203 9.5835C7.96274 9.5835 9.08203 8.46421 9.08203 7.0835C9.08203 5.70278 7.96274 4.5835 6.58203 4.5835C5.20132 4.5835 4.08203 5.70278 4.08203 7.0835C4.08203 8.46421 5.20132 9.5835 6.58203 9.5835Z"
      stroke={color}
      strokeMiterlimit="10"
    />
    <path
      d="M12.4167 7.08333C12.4167 5.53624 11.8021 4.05251 10.7081 2.95854C9.61416 1.86458 8.13043 1.25 6.58333 1.25C5.03624 1.25 3.55251 1.86458 2.45854 2.95854C1.36458 4.05251 0.75 5.53624 0.75 7.08333C0.75 10.305 6.58333 18.75 6.58333 18.75C6.58333 18.75 12.4167 10.305 12.4167 7.08333Z"
      stroke={color}
      strokeMiterlimit="10"
    />
  </svg>
);

export default MapIcon;
